// GENERATED, DON'T EDIT MANUALLY, SEE icons SCRIPT

import React from 'react';
import type { SVGAttributes } from 'react';

export default function IconCircleCheck(props: SVGAttributes<SVGElement>) {
	return (
		<svg {...props} width="24" height="24" viewBox="0 0 24 24">
			<path d="m10.6 13.8-2.15-2.15a.95.95 0 0 0-.7-.28.95.95 0 0 0-.97.97c0 .3.09.53.27.71L9.9 15.9c.2.2.43.3.7.3s.5-.1.7-.3l5.65-5.65a.95.95 0 0 0 .28-.7.95.95 0 0 0-.98-.98c-.28 0-.52.1-.7.28zM12 22a10.08 10.08 0 0 1-9.21-6.1A9.7 9.7 0 0 1 2 12a10.1 10.1 0 0 1 6.1-9.21A9.7 9.7 0 0 1 12 2a10.1 10.1 0 0 1 9.21 6.1c.53 1.22.79 2.52.79 3.9s-.26 2.68-.79 3.9a10.08 10.08 0 0 1-5.31 5.31A9.7 9.7 0 0 1 12 22" />
		</svg>
	);
}
IconCircleCheck.displayName = 'IconCircleCheck';
